import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ isSignedIn, children, admin }) {
  if (!isSignedIn) {
    return admin ? (
      <Navigate to="/login-admin" />
    ) : (
      <Navigate to="/" />
    );
  } else {
    return children;
  }
}
